import React, { FC, ReactElement } from 'react';
import Badge from 'atomic/badge';
import OfferLabelInterface from 'interfaces/offer-label.interface';

interface OfferLabelProps {
    label?: OfferLabelInterface | null;
    className?: string;
}

const OfferLabel: FC<OfferLabelProps> = ({ label, className }): ReactElement | null => {
    if (!label) {
        return null;
    }

    return (
        <Badge
            className={className}
            weight="600"
            backgroundColor={label.backgroundColor}
            textColor={label.textColor}
        >
            <span>{label.name}</span>
        </Badge>
    );
};

export default OfferLabel;
